import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { Constants } from '../utils';

/**
 * array of keys that will be persisted to the sessionStorage
 * eg: user: [{ data: ['email'] }] -> will persist the root user key from the state,
 * and from the user it will persist only the email prop from data
 */
const keysToPersist = [
  {
    app: [
      'selectedSubprojectId',
      'loginPageDisplayed',
      'isAppLockedInOffline',
      'gridState',
      'dprsSortingDirection',
    ],
  },
  { userDetails: ['data'] },
  {
    offline: [
      'dprDetailsList',
      'dprDetails',
      'backupUserDetails',
      'backupLastDprs',
      'backupAuthenticationResult',
      'dprDetailsOfflineChanges',
      'syncOfflineGuid',
    ],
  },
];

function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: keysToPersist,
    rehydrate: true,
    storageKeySerializer: (key: any) =>
      `${Constants.State.StoreKeyPrefix}${key}`,
    storage: localStorage,
  })(reducer);
}

export const metaReducers = [localStorageSyncReducer];
